import WebEmitter from './webEmitter'

let emitter = new WebEmitter()

export default emitter
